import { Button,} from "@chakra-ui/react";
import { useEthers, useEtherBalance, useTokenBalance } from "@usedapp/core";
import { formatEther } from "@ethersproject/units";
import { HERA_TOKEN } from "../constants/constrants";


type Props = {
  handleOpenModal: any;
};

export default function ConnectButton({ handleOpenModal }: Props) {
  const { activateBrowserWallet, account } = useEthers();

  const etherBalance = useEtherBalance(account)
  const usdcBalance = useTokenBalance(HERA_TOKEN,account);

  function handleConnectWallet() {
    activateBrowserWallet();
  }

  return account ? (
    <>
    <li className="buy-token" style={{marginRight:"25px"}}>

             <Button className="readon black-shape"   _hover={{ bg: "none" }}  borderRadius="0" h="50px" w="fit-content" bg="none" leftIcon={<img src="assets/hera.png" alt="Hera" />}>
                  <span className="btn-text">Balance: {usdcBalance && parseFloat(formatEther(usdcBalance)).toFixed(3)} </span>
                  <i className="icon-arrow_down" />
                  <span className="hover-shape1" />
                  <span className="hover-shape2" />
                  <span className="hover-shape3" />
                </Button>
                <ul>
                <li><a style={{display: "flex", alignItems:"center"}}><img src="assets/hera.png" alt="Hera" /> {usdcBalance && parseFloat(formatEther(usdcBalance)).toFixed(3)} HERA</a></li>
                  <li><a style={{display: "flex", alignItems:"center"}}><img src="assets/metis.png" alt="metis" /> {etherBalance && parseFloat(formatEther(etherBalance)).toFixed(3)}  METIS</a></li>
                </ul>
              </li>
              <li>
                <Button borderRadius="0" h="50px" w="full" onClick={handleOpenModal} className="readon white-btn hover-shape connected"><img src="assets/images/icons/connect.png" alt="Icon" /> 
                  <span className="btn-text">{account &&
            `${account.slice(0, 6)}...${account.slice(
              account.length - 4,
              account.length
            )}`} </span>
                  <span className="hover-shape1" />
                  <span className="hover-shape2" />
                  <span className="hover-shape3" />
                </Button>
              </li>
    </>
  ) : (
    <li>
    <Button  borderRadius="0" h="50px" w="full" alignItems={"center"} onClick={handleConnectWallet} className="readon white-btn hover-shape" ><img src="assets/images/icons/connect.png" alt="Icon" /> 
      <span className="btn-text">Connect Wallet </span>
      <span className="hover-shape1" />
      <span className="hover-shape2" />
      <span className="hover-shape3" />
    </Button>
  </li>
  );
}
